<div
  [formGroup]="userForm"
  class="pssr-form-group">
  @if (showUserTypeSelector() && options() && options().length > 0) {
    <div class="pssr-form-control">
      @if (showUserTypeLabel()) {
        <label class="pssr-form-label">
          {{ 'participantDialog.selectUserType' | translate }}
        </label>
      }
      <div class="pssr-radio-group">
        @for (option of options(); track option) {
          <div class="pssr-radio-control">
            <p-radiobutton
              [value]="option"
              [disabled]="options().length === 1"
              [inputId]="UserType[option]"
              (onClick)="selectedOptionChanged($event)"
              formControlName="selectedOption"
              name="userType"
              class="pssr-radio" />
            <label
              [htmlFor]="UserType[option]"
              class="pssr-radio-label">
              {{ 'userType.' + UserType[option] | translate }}
            </label>
          </div>
        }
      </div>
    </div>
  }
  @let selectedOption = userForm.get('selectedOption')?.value;

  <div
    [hidden]="selectedOption !== UserType.Chevron"
    class="pssr-form-control">
    <app-user-search-control
      [isReadOnly]="isReadOnly()"
      [defaultValue]="defaultSelectedUser"
      [invalid]="isChevronUserInvalid()"
      formControlName="chevronUser"></app-user-search-control>
    @if (isChevronUserInvalid()) {
      <small class="error-message">
        {{
          'app.forms.validation.required'
            | translate: { controlName: ('externalUserForm.labels.userNameEmail' | translate) }
        }}
      </small>
    }
  </div>

  <app-external-user-form
    [hidden]="selectedOption !== UserType.External"
    [isReadOnly]="isReadOnly()"
    [actionTemplate]="externalActionTemplate()"
    formControlName="externalUser"></app-external-user-form>

  <app-shared-user-form
    [hidden]="selectedOption !== UserType.Shared"
    [isReadOnly]="isReadOnly()"
    formControlName="sharedUser"></app-shared-user-form>
</div>
